export default __webpack_public_path__ + "static/media/card.45a9d609.svg";